import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { IExtensionCalling } from "./Table";
import { Fetch } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import { IUsersDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";

interface IProps {
    singleData: IExtensionCalling,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema = yup.object({
    callerID: yup.string().required("Caller Id is required"),
    ext_Destination: yup.string().required("Extension is required"),

});

export const Form = (props: IProps) => {
    const [saveDis, setSaveDis] = useState(false);
    const [users, setUser] = useState<Array<any>>();
    const [selectedUser, setSelectedUser] = useState<Array<number | any | IUsersDropdown>>([]);


    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IExtensionCalling>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const iVR_Company = [
        { name: 'Tekinspirations' },
        { name: 'Originator' },
        { name: 'Inventivo' },
    ]
    const branch_Name_Dropdown = [
        { name: 'Varanasi' },
        { name: 'Noida' },
        { name: 'Agra' },
        { name: 'Meerut' },
        { name: 'Ranchi' },
        { name: 'Bhubaneswar' },
    ]

    const onSubmit = (data: IExtensionCalling) => {
        if (selectedUser.length == 0 || selectedUser == null) {
            props.toast.current.show({ severity: 'error', detail: "Please Select Atleast one User", life: 3000 });
        } else {
            setSaveDis(true);
            saveToDB(data);
        }
    }
    interface Link_User_IDs {
        login_ID: number
    }
    const saveToDB = async (data: any) => {
        const method = props.singleData.extension_ID != null ? "PUT" : "POST";
        const message = props.singleData.extension_ID != null ? "Updated Successfully" : "Added Successfully";
        const _link_User: Array<Link_User_IDs> = selectedUser?.map(login_ID => ({ login_ID })) || [];
        let query: null | string = null;

        if (_link_User.length > 0) query = query + "&linkUser=" + JSON.stringify(_link_User);
        const response = await Fetch("Calling_Extension", method, data, query, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
            setSelectedUser([])

            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
    }

    const loadUser = async () => {
        const response = await Fetch("Dropdown/InHouseUserList", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setUser(data);
        }
    }

    const loadLinkedUser = async (id: number) => {
        const response = await Fetch("Dropdown/getCallingextUsers", "GET", null, `extension_id=${id}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const _users = (users || [])
                .filter(user => data.some(d => d.login_ID === user.login_ID))
                .map(user => user.login_ID); // Extract only login_IDs

            setSelectedUser(_users);

        }
    };

    const onHide = () => {
        setSelectedUser([])
        props.hideDialog();
    }

    useEffect(() => {
        loadUser();
    }, []);

    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.extension_ID) {
            loadLinkedUser(props.singleData.extension_ID);
        }

    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Calling Extension" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={2} required label="Caller ID" control={control} name="callerID" error={errors.callerID?.message} />
                <JVInput column={2} required label="Ext/ Destination" control={control} name="ext_Destination" error={errors.ext_Destination?.message} />
                <JVDropdown column={2} label="IVR Company" control={control} name="ivR_Company" options={iVR_Company} optionLabel="name" optionValue="name" placeholder="Select IVR Company" />
                <JVDropdown column={2} label="Branch Name" control={control} name="branch_Name" options={branch_Name_Dropdown} optionLabel="name" optionValue="name" placeholder="Select Branch Name" />
                <JVInput column={2} label="Display Name" control={control} name="displayName" />

                <div style={{ width: '49%' }} >
                    <label className="ml-3" style={{ display: 'block', marginBottom: '8px' }}>Select Users<small className="p-error" ></small></label>
                    <MultiSelect value={selectedUser} onChange={(e) => setSelectedUser(e.value)} options={users} optionLabel="user_Name" optionValue="login_ID" display="chip" filter placeholder="Select User" maxSelectedLabels={10} className=" ml-3 mb-3" />
                </div>
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" disabled={saveDis}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}